import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { UserService } from "../_services/user.service";
import { AuthGuard } from "../_guards/auth.guard";
import { AuthInterceptor } from "../_guards/auth.interceptor";

import { MntMasterRoutingModule } from './mnt-master-routing.module';
import { MasterLayoutComponent } from './master-layout/master-layout.component';
import { MasterMenuComponent } from './master-menu/master-menu.component';
import { AppMaterialModule } from '../app-material/app-material.module';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { CustomTabComponent } from './custom-tab/custom-tab.component';
import { FieldErrorDisplayComponent } from './field-error-display/field-error-display.component';
import { CustomLoaderComponent } from './custom-loader/custom-loader.component';

import { SharedModule } from "../shared/shared.module";
import { ConfirmationDialogComponent } from '../shared/confirmation-dialog/confirmation-dialog.component';
import { CreateClientComponent } from './create-client/create-client.component';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import {NgxMaskModule, IConfig} from 'ngx-mask';
import { AnnouncementDetailComponent } from './announcement-detail/announcement-detail.component';
import { RegisterClientComponent } from './register-client/register-client.component';
import { LoginClientComponent } from './login-client/login-client.component';
import { WatchTutorialComponent } from './watch-tutorial/watch-tutorial.component';

export const options: Partial<IConfig> = {
};

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    MntMasterRoutingModule,
    HttpClientModule,
    FlashMessagesModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule.forRoot(options)
  ],
  declarations: [
    MasterLayoutComponent,
    MasterMenuComponent,
    CustomTabComponent,
    FieldErrorDisplayComponent,
    CustomLoaderComponent,
    ConfirmationDialogComponent,
    CreateClientComponent,
    AnnouncementDetailComponent,
    RegisterClientComponent,
    LoginClientComponent,
    WatchTutorialComponent
  ],
  providers: [
    UserService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  exports: [MasterLayoutComponent, MasterMenuComponent, CustomTabComponent,  FieldErrorDisplayComponent   , CustomLoaderComponent, ConfirmationDialogComponent, WatchTutorialComponent],
  entryComponents: [ ConfirmationDialogComponent,CreateClientComponent,AnnouncementDetailComponent, RegisterClientComponent, LoginClientComponent, WatchTutorialComponent ]
})
export class MntMasterModule {}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-master/mnt-master.module.ts